import Mixin from "../mixin.js";
import Utils from "../services/utils-service.js";
import Label from "./utils/Label.js";
import Funnel from "../services/funnel-service.js";
import InputText from "./utils/InputText.js";
import InputSelect from "./utils/InputSelect.js";
import InputDate from "./utils/InputDate.js"
const template = `
 <div v-if="fs.display(input)">

	<div class="grid" :uid="input.uid"  >
		<div class="s12 m10 l4 clm center " v-for="(card, index) in cards" :uid="input.uid +'_option_'+ index" v-if="cardNotEmpty(card.name)">
			<div class="card home-prefill-card">
				<h1 class="text-center">
					<img class="iconic icon " data-state="up" :data-src="icon(card)">
					{{card.title}}
				</h1>
				<div class="divider solid"></div>

				<table class="coverage-table">
					<tr v-for='input_uid in cards_map[card.name]' v-if="prefillValueReturned(input_uid) && fs.display(funnel.elements[input_uid])">
						<td class="text-right" width="50%" :id="input_uid+'_label'">
							{{funnel.elements[input_uid].label}}:
						</td>
						<td class="text-left" width="50%" :id="input_uid+'_value'">
							{{theValue(funnel.elements[input_uid])}}
						</td>
					</tr>
				</table>

				<button class="button medium circle edit primary-btn curcular-btn center" @click.prevent="toggleModal(index)" />
			</div>
		</div>
	</div>
	
	<transition-group name="modal" tag="ul" @enter="computeMarginTop(), fs.transitionEnter()">
		<div class="modal-mask"  :ref="'card_'+index" v-for="(card, index) in cards" v-if="card.display_modal" :key="'modal_'+index" >
			<div class="modal-wrapper">
				<div class="s11 m10 l6 clm center" :style="styleObject">
					<div class="card modal-card" :id="iuid+'_modal_card'">
						<div class="modal-header">
							<slot name="header">
                                
								<h2 class="text-center">
                                    <img :alt="'Edit '+ card.title+ ' Icon'" class="iconic iconic-md icon" data-state="up" :data-src="icon(card)">
									Edit {{card.title}}
								</h2>
						
							</slot>
						</div>
						<div class="divider solid"></div>
						<div class="modal-body grid">
							<div class="s12 clm" v-for="input_uid in cards_map[card.name]"  v-if="funnel.elements.in_home_prefill_data_returned.value.indexOf(input_uid) !== -1">
								<qt-input-text v-if="fs.display(funnel.elements[input_uid]) && (funnel.elements[input_uid].type === 'text' || funnel.elements[input_uid].type === 'number')" :iuid="funnel.elements[input_uid].uid"/>
								<qt-input-date v-if="fs.display(funnel.elements[input_uid]) && (funnel.elements[input_uid].type === 'date')" :iuid="funnel.elements[input_uid].uid"/>
								<qt-input-select v-if="fs.display(funnel.elements[input_uid]) && (checkSelectType(input_uid) || funnel.elements[input_uid].type === 'spinner')"  :iuid="funnel.elements[input_uid].uid"/>
							</div>
							<div class="s12 clm">
								<slot name="footer">
									<button aria-label="Save changes" class="button medium circle primary-btn save" @click.prevent="toggleModal(index)"/>
								</slot>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition-group>
</div>
`;
// :title="table_item.tooltip" :class="table_item.tooltip ? 'tooltip' : '' "
// v-if="funnel.elements[input_uid].value"
export default {
    name: 'b-home-prefill',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
        'qt-input-text': InputText,
        'qt-input-select': InputSelect,
        'qt-input-date':InputDate,
        'qt-label': Label
    },
    data () {
        return {
            styleObject:{},
            cards_map:{

            "basic":[
                    "in_home_square_footage",
                    "in_home_number_of_stories",
                    "in_home_full_bath",
                    "in_home_half_bath",
                    "in_home_rating_info_dwelling",
                    "in_home_year_built",
                    "in_home_purchase_price"
                ],
                "structure":[
                    "in_home_structure",
                    "in_home_construction",
                    "in_home_basement_type",
                    // "in_home_basement_finished_percentage",
                    "in_home_foundation",
                    "in_home_have_garage",
                    "in_home_garages_and_carports",
                    "in_home_land_under_foundation",
                    "in_home_roof_shape",
                    "in_home_roof",
                    "in_home_roofing_update"
                ],
                "extras":[
                    "in_home_extras",
                    "in_home_pool_type",
                    "in_home_pool_fenced"
                ]

            },
           cards:[
               {
                   title:"Details" ,
                   name:"basic",
                   icon_name:"homedetails",
                   display_modal:false,
                   tooltip:'tooltip 1'
               },
               {
                   title:"Structure",
                   name:"structure",
                   icon_name:"homestructure",
                   display_modal:false,
                   tooltip:'tooltip 2'
               },
               {
                   title:"Extras",
                   name:"extras",
                   icon_name:"homeextras",
                   display_modal:false,
                   tooltip:'tooltip 3'
               }

           ]
        }
    },
    computed: {
        ...Vuex.mapGetters([
            'funnel'
        ]),
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        svgClass: function () {
            if (this.input.img.indexOf('.svg') != -1) {
                return 'icon iconic center'
            }
        },
        gridClass: function () {
            return 'block-grid-l5'
        },
        validationRules() {
            // v-bind="validationRules"
            return this.input.validation
        },
        input: function () {
            delete this.$store.getters.funnel.elements[this.iuid].icon_name;
            return this.$store.getters.funnel.elements[this.iuid];
        },
        items: function () {
            return { ... this.input.options };
        },
        radio_count: function () {
            return 's12 clm'
        }


    },
    mounted: function(){
        // console.log(this.funnel);
    },
    methods: {
        computeMarginTop: function(){
            this.styleObject = {}
            var modal = document.getElementById(this.iuid+'_modal_card');
            var body = document.body;
            // var w = modal.offsetWidth;
            var h = modal.offsetHeight;
            var wh = window.innerHeight;
            // var bw = body.clientWidth;
            if (h >= wh) {
              return
            }
            this.styleObject.marginTop = (wh/2 - h/2) - 35+ "px"
            this.$forceUpdate()
        },
        cardNotEmpty: function(cardName){
            var emptys = []
            var self = this;

            this.cards_map[cardName].map(function(uid){
                // if (typeof self.funnel.elements[uid].value === 'object' && Object.keys(self.funnel.elements[uid].value).length == 0) {
                //     emptys.push(uid)
                // }
                // if (!self.funnel.elements[uid].value) {
                //     emptys.push(uid)
                // }
                if(self.funnel.elements.in_home_prefill_data_returned.value != false && self.funnel.elements.in_home_prefill_data_returned.value.indexOf(uid) === -1){
                    emptys.push(uid)
                }
            })
            if (emptys.length != this.cards_map[cardName].length) {
                return true
            }
        },
        theValue: function(input){
            if (Array.isArray(input.value)) {
                for (var i = input.value.length - 1; i >= 0; i--) {
                    if (input.value[i].label != undefined) {
                        if (i.length == i.length -1) {
                             var value = input.value[i].label.toString().toLowerCase()
                            return value
                        }else{
                           var value = input.value[i].label.toString().toLowerCase()
                            return value + ", "
                        }
                    }else{
                       var value = input.value.toString().toLowerCase()
                       return value
                   }
                }
            }else{
                var value = input.value.toString().toLowerCase()
                return value
            }
        },
        prefillValueReturned: function(input_uid){
            // if (typeof this.funnel.elements[input_uid].value === 'object' && Object.keys(this.funnel.elements[input_uid].value).length == 0) {
            //     return false
            // }
            // if (this.funnel.elements[input_uid].value != 0 || this.funnel.elements[input_uid].value || this.funnel.elements[input_uid].value.length != 0) {
            //
            //     return true
            // }

            if(this.funnel.elements.in_home_prefill_data_returned.value != false && this.funnel.elements.in_home_prefill_data_returned.value.indexOf(input_uid) !== -1){
                return true
            }
            else{
                return false
            }

        },
        checkSelectType: function(input_uid){
            if (this.funnel.elements[input_uid].type === 'select' || (this.funnel.elements[input_uid].type === 'checkbox' || this.funnel.elements[input_uid].type === 'radio')) {
                // console.log(this.funnel.elements[input_uid].uid, this.funnel.elements[input_uid].type);
                return true
            }

        },
        toggleModal: function(i){
            this.cards[i].display_modal = !this.cards[i].display_modal
            if (this.cards[i].display_modal ) {
                document.body.classList.add("no-scroll");
            }else{
                document.body.classList.remove("no-scroll");
            }

        },
        hideModal: function(i){
            this.cards[i].display_modal = false
        },
        maskClick: function(e, i ){
            if (e.className.indexOf('modal-mask') > -1 || e.className.indexOf('modal-wrapper') > -1) {
                this.toggleModal(i)
            }
        },
        setValue(item) {
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_coverage_select', key: 'value', val: item.value });

            const pages_sequence = this.$store.getters.funnel.idsMap.pages_sequence;
            const indx = pages_sequence.indexOf('pg_coverage_customize')
            pages_sequence.splice(indx, 1);
            this.$store.commit('UPDATE_PAGES_SEQ', pages_sequence);
        },
        setChecked(item) {
            var checked = false;
            if (!Utils.isEmpty(this.input.value)) {
                checked = this.input.value.indexOf(item.value) > -1;
            }
            return checked;
        },
        icon: function (item) {
            if (item.icon_name) {
                var text = item.icon_name
            } else {
                var text = this.input.label
            }

            const pathToIcon = '/static/images/card-icons/'
            const iconFormat = '.svg'
            const iconName = text.toLowerCase().split(" ").join("-").replace(/[^a-zA-Z ]/g, "");

            return pathToIcon + iconName + iconFormat;
        }
    }
};
